import React, { useCallback, useEffect, useRef, useState } from 'react';
import { AlertTriangle, CheckCircle2, Info } from 'lucide-react';

/**
 * The portal's toast (handoff §Toasts: ok / info / warn). A fixed overlay at the bottom of
 * the viewport, so showing it never moves the page (D7). Render `node` inside `.etp`.
 */

export type ToastKind = 'ok' | 'info' | 'warn';

export function usePortalToast(): { node: React.ReactNode; show: (msg: string, kind?: ToastKind, ms?: number) => void } {
  const [t, setT] = useState<{ msg: string; kind: ToastKind; on: boolean }>({ msg: '', kind: 'ok', on: false });
  const timer = useRef<number | null>(null);
  const show = useCallback((msg: string, kind: ToastKind = 'ok', ms = 3400) => {
    setT({ msg, kind, on: true });
    if (timer.current) window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setT((x) => ({ ...x, on: false })), ms);
  }, []);
  useEffect(() => () => { if (timer.current) window.clearTimeout(timer.current); }, []);
  const Icon = t.kind === 'warn' ? AlertTriangle : t.kind === 'info' ? Info : CheckCircle2;
  const node = (
    <div className={`ep-toast${t.on ? ' on' : ''}`} data-k={t.kind} role="status" aria-live="polite">
      <Icon /><span>{t.msg}</span>
    </div>
  );
  return { node, show };
}
